/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  //Checkbox,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Alert,
  Chip,
  useTheme,
  alpha,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Collapse,
  Checkbox,
  ListItemText,
  Tooltip
} from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers';
import {
  Add,
  Edit,
  Delete,
  // Description,
  // History,
  Search as SearchIcon,
  ClearAll,
  CalendarToday,
  Warning,
  KeyboardArrowDown,
  KeyboardArrowRight
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { httpRequest } from 'src/services/httpRequest';
import toast from 'react-hot-toast';
import UploadedFilesDetails from '../Reports/Bid-Summary/UploadedFilesDetails';
import DownloadDetails from '../Reports/Bid-Summary/DownloadDetails';
import BidResultsDetails from './BidResultsDetails';
import UploadPODetails from './UploadPODetails';
import DownloadChildBidDetails from '../Reports/Bid-Summary/DownloadChildBidDetails';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { addCommaWithTwoDecimals } from 'src/services/common';
// import { handlePreviewFile } from 'src/services/common';

interface BidDocument {
  BidDocsID: number;
  BidID: number;
  DocumentName: string;
  DocumentUrl: string;
  Active: boolean;
  InsertDate: string;
  UpdateDate: string | null;
  DeleteDate: string | null;
  RowStatus: number;
  TownshipID: number;
  InsertedBy: number;
  UpdatedBy: number | null;
  DeletedBy: number | null;
  DocumentType: string;
  DocumentDescription: string;
}
// Types interfaces remain the same
interface Bid {
  contractNo: string;
  bidId: string;
  bidType: string;
  title: string;
  adminNote: string;
  category: string;
  goLiveDate: string;
  dueDate: string;
  status: string;
  uploadedFiles: number;
  downloads: number;
  awardedToVendor: {
    Business: string;
  };
  awardedToId: number | null;
  poFlag: boolean;
  poDocument: string;
  poLocation: string;
  signedPoFlag: boolean;
  invoiceFlag: boolean;
  invoiceDocument: string;
  invoiceLocation: string;
  departmentId: string;
  bidResults: string;
  Po: string;
  signedPo: string;
  invoice: string;
  documentFiles?: { fileName: string; fileUrl: string }[];
  documents: BidDocument[];
  childBidDocuments: BidDocument[];
  awardedToContact: {
    FirstName: string;
    LastName: string;
    EmailID: string;
  };
  AwardedTo: string;
  awardAmount: string;
  isAddendum: boolean; // Ensure this field is correctly typed
  childItems?: Bid[]; // childItems should be an array of Bid, not just a partial structure
}

interface SearchCriteria {
  title: string;
  contractNo: string;
  awardedTo: string;

  categories: number[];
  statuses: number[];
  bidTypes: number[];
  bidDeadline: Date | null;
  adDate: Date | null;
  openingDate: Date | null;
  // showOnlyAwarded: boolean;
}

interface BidResponse {
  awardedTo: string[];
  awardedToContact: {
    FirstName: string;
    LastName: string;
    EmailID: string;
  };
  BidID: number;
  TypeID: number;
  ContractNo: string;
  Title: string;
  CategoryIDs: number[];
  DepartmentID: number;
  GoLiveDate: string;
  BidDeadLineDate: string;
  AwardDate: string | null;
  AdDate: string;
  OpeningDate: string;
  EffectiveDate: string | null;
  StatusID: number;
  Description: string | null;
  AdminNote: string | null;
  IsPublish: boolean;
  ReasonToReopen: string | null;
  AwardedToVendor: any;
  ReasonToReject: string | null;
  TownshipID: number;
  Active: boolean;
  RowStatus: number;
  CreateDate: string;
  CreatedBy: number;
  UpdateDate: string;
  UpdatedBy: number;
  DeleteDate: string | null;
  DeletedBy: number | null;
  Categories: {
    CategoryID: number;
    CategoryName: string;
  }[];
  Status: string;
  Type: string;
  Downloads: number;
  Documents: {
    BidDocsID: number;
    BidID: number;
    DocumentName: string;
    DocumentUrl: string;
    Active: boolean;
    InsertDate: string;
    UpdateDate: string | null;
    DeleteDate: string | null;
    RowStatus: number;
    TownshipID: number;
    InsertedBy: number;
    UpdatedBy: number | null;
    DeletedBy: number | null;
    DocumentType: string;
    DocumentDescription: string;
  }[];

  bidResults: string;
  Po: string;
  signedPo: string;
  invoice: string;
  AwardedTo: string;
  AwardAmount?: number;
  IsAddendum: boolean;
  IsDocumentProcessing: boolean;
  ChildBidDocuments: [];
}

interface APIResponse {
  status: string;
  message: string;
  data: {
    TotalRecords: number;
    CurrentPage: number;
    TotalPages: number;
    Data: BidResponse[];
  };
}

interface TypeOption {
  TypeID: number;
  Type: string;
  Active: boolean;
}

interface CategoryOption {
  CategoryID: number;
  CategoryName: string;
}

interface StatusOption {
  StatusID: number;
  Status: string;
  Active: boolean;
}

// Dialog state interface
interface DeleteDialogState {
  open: boolean;
  bidId: string;
  bidTitle: string;
}

interface BidDetails {
  contractNo: string;
  title: string;
  categories: string;
  documents?: BidDocument[];
  childBidDocuments?: BidDocument[];
  awardAmount?: number;
  awardedToId?: number | null; // Add this
  awardedToBusiness?: any; // Add this
  awardedToContact?: {
    FirstName: string;
    LastName: string;
    EmailID: string;
    UserID?: number;
  } | null; // Add this
}

interface UploadedFilesDetailsState {
  isOpen: boolean;
  bidId: string;
  bidDetails: BidDetails;
}

interface DownloadDetailsState {
  isOpen: boolean;
  bidId: string;
  bidDetails: BidDetails;
}

interface DownloadChildDetailsState {
  isOpen: boolean;
  bidId: string;
  parentBidId: string;
  bidDetails: BidDetails;
}

interface BidResultsDetailsState {
  isOpen: boolean;
  bidId: string;
  bidDetails: BidDetails;
}

interface UploadPODetailsState {
  isOpen: boolean;
  bidId: string;
  bidDetails: BidDetails;
}

interface ChildDeleteDialogState {
  open: boolean;
  childBidId: string;
  childBidTitle: string;
  parentBidId: string;
}

const SearchBidsPage: React.FC = () => {
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const theme = useTheme();

  const [searchCriteria, setSearchCriteria] = useState<SearchCriteria>({
    title: '',
    categories: [],
    statuses: [],
    bidTypes: [],
    bidDeadline: null,
    adDate: null,
    openingDate: null,
    // ,showOnlyAwarded: false,
    contractNo: '',
    awardedTo: ''
  });

  const { state: locationState, township, uuid } = useParams();

  const [bids, setBids] = useState<Bid[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const userRole = userDetails.UserRole || '';

  // State for dropdown data
  const [categories, setCategories] = useState<CategoryOption[]>([]);
  const [types, setTypes] = useState<TypeOption[]>([]);
  const [statuses, setStatuses] = useState<StatusOption[]>([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
  const [dropdownError, setDropdownError] = useState<string | null>(null);
  const [openCategorySelect, setOpenCategorySelect] = useState(false);
  const [openStatusSelect, setOpenStatusSelect] = useState(false);
  const [openTypeSelect, setOpenTypeSelect] = useState(false);
  const [pollingTimer, setPollingTimer] = useState<NodeJS.Timeout | null>(null);

  const [childDeleteDialog, setChildDeleteDialog] =
    useState<ChildDeleteDialogState>({
      open: false,
      childBidId: '',
      childBidTitle: '',
      parentBidId: ''
    });
  // Dialog state
  const [deleteDialog, setDeleteDialog] = useState<DeleteDialogState>({
    open: false,
    bidId: '',
    bidTitle: ''
  });

  const [uploadedFilesDetailsState, setUploadedFilesDetailsState] =
    useState<UploadedFilesDetailsState>({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });

  const [bidResultsDetailsState, setBidResultsDetailsState] =
    useState<BidResultsDetailsState>({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });

  const [uploadPODetailsState, setUploadPODetailsState] =
    useState<UploadPODetailsState>({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });

  const [downloadDetailsState, setDownloadDetailsState] =
    useState<DownloadDetailsState>({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });

  const [downloadChildDetailsState, setDownloadChildDetailsState] =
    useState<DownloadChildDetailsState>({
      isOpen: false,
      parentBidId: '',
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });

  // Handle uploads click - open uploaded files details view with scroll to top
  const handleUploadsClick = (bid: any) => {
    setUploadedFilesDetailsState({
      isOpen: true,
      bidId: bid.bidId,
      bidDetails: {
        contractNo: bid.contractNo || bid?.ContractNo,
        title: bid.title || bid.Title,
        categories:
          bid.category ||
          bid?.Categories?.map((cat) => cat.CategoryName).join(', ') ||
          '',
        documents: bid.documents,
        childBidDocuments: bid.childBidDocuments || bid.ChildBidDocuments
      }
    });
  };

  const navigate = useNavigate();

  // Fetch dropdown data (categories, types, statuses)
  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoadingDropdowns(true);
      setDropdownError(null);
      try {
        // Fetch categories
        const categoriesResponse = await httpRequest(
          'GET',
          `/bid_portal/category/get_all`,
          {},
          {}
        );

        if (categoriesResponse.status === 'success') {
          const categoriesData =
            categoriesResponse.data?.data ||
            categoriesResponse.data?.Data ||
            [];
          setCategories(categoriesData);
        } else {
          console.error('Failed to fetch categories:', categoriesResponse);
          setDropdownError('Failed to load categories. Please try again.');
        }

        // Fetch types
        const typesResponse = await httpRequest(
          'GET',
          `/bid_portal/type/get_all`,
          {},
          {}
        );

        if (typesResponse.status === 'success') {
          const typesData =
            typesResponse.data?.data || typesResponse.data?.Data || [];
          setTypes(typesData);
        } else {
          console.error('Failed to fetch types:', typesResponse);
          setDropdownError('Failed to load bid types. Please try again.');
        }

        // Fetch statuses
        const statusesResponse = await httpRequest(
          'GET',
          `/bid_portal/status/get_all`,
          {},
          {}
        );

        if (statusesResponse.status === 'success') {
          const statusesData =
            statusesResponse.data?.data || statusesResponse.data?.Data || [];
          setStatuses(statusesData);
        } else {
          console.error('Failed to fetch statuses:', statusesResponse);
          setDropdownError('Failed to load statuses. Please try again.');
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
        setDropdownError('Failed to load form options. Please try again.');
      } finally {
        setLoadingDropdowns(false);
      }
    };

    fetchDropdownData();
  }, []);

  const fetchBidsWithoutLoader = async (
    pageNum: number,
    pageSize: number,
    criteria: SearchCriteria = searchCriteria
  ) => {
    try {
      // Construct query parameters using the passed criteria instead of state
      const queryParams = new URLSearchParams({
        Page: (pageNum + 1).toString(),
        Size: pageSize.toString(),
        ...(criteria.title && { Title: criteria.title }),
        ...(criteria.categories?.length > 0 && {
          Categories: criteria.categories.join(',')
        }),
        ...(criteria.statuses?.length > 0 && {
          Status: criteria.statuses.join(',')
        }),
        ...(criteria.bidTypes?.length > 0 && {
          Type: criteria.bidTypes.join(',')
        }),
        ...(criteria.adDate && {
          AdDate: criteria.adDate.toISOString()
        }),
        ...(criteria.openingDate && {
          OpeningDate: criteria.openingDate.toISOString()
        }),
        ...(criteria.awardedTo && { AwardedTo: criteria.awardedTo }),
        ...(criteria.contractNo && { ContractNo: criteria.contractNo })
      });

      const response = (await httpRequest(
        'GET',
        `/bid_portal/bid_details/get?${queryParams.toString()}`
      )) as APIResponse;

      if (response.status === 'success') {
        // ... rest of your fetchBids logic remains the same
        const transformedBids: any = response?.data?.Data?.map((bid) => ({
          contractNo: bid?.ContractNo,
          bidId: bid?.BidID?.toString() || '',
          bidType: bid?.Type,
          title: bid?.Title,
          adminNote: bid?.AdminNote || '',
          category:
            bid?.Categories?.map((cat) => cat.CategoryName).join(', ') || '',
          goLiveDate: bid?.GoLiveDate,
          dueDate: bid?.BidDeadLineDate,
          adDate: bid?.AdDate,
          openingDate: bid?.OpeningDate,
          status: bid?.Status,
          uploadedFiles:
            (bid?.Documents?.filter(
              (doc) => doc.DocumentDescription === 'Bid Document'
            )?.length || 0) + (bid.ChildBidDocuments?.length || 0),

          documentFiles:
            bid?.Documents?.map((doc) => ({
              fileName: doc.DocumentName,
              fileUrl: doc.DocumentUrl
            })) || [],
          downloads: bid?.Downloads,
          poFlag: false,
          poDocument: '',
          poLocation: '',
          signedPoFlag: false,
          invoiceFlag: false,
          invoiceDocument: '',
          invoiceLocation: '',
          departmentId: bid?.DepartmentID?.toString() || '',
          bidResults: bid?.bidResults,
          Po: bid?.Po,
          signedPo: bid?.signedPo,
          invoice: bid?.invoice,
          awardedTo: bid?.awardedTo || { Business: '' },
          awardedToVendor: bid?.AwardedToVendor?.Business || null, // Add this
          awardedToContact: bid?.awardedToContact || null, // Add this
          // now typed as BidDocument[]
          documents: (bid?.Documents || []) as BidDocument[],
          awardedToId: bid?.AwardedTo,
          awardAmount: bid?.AwardAmount,
          isAddendum: bid.IsAddendum || false, // Check for addendum
          childItems: [], // Initially empty, will be populated later,
          childBidDocuments: (bid?.ChildBidDocuments || []) as BidDocument[],
          isDocumentProcessing: bid?.IsDocumentProcessing
        }));

        setBids(transformedBids);
        setTotalCount(response.data.TotalRecords);

        // Check if any bid has IsDocumentProcessing = true
        const hasProcessingDocuments = transformedBids.some(
          (bid: any) => bid.isDocumentProcessing === true
        );

        // Clear existing timer if any
        if (pollingTimer) {
          clearTimeout(pollingTimer);
          setPollingTimer(null);
        }

        // Set new timer if there are processing documents
        if (hasProcessingDocuments) {
          const timer = setTimeout(() => {
            fetchBidsWithoutLoader(pageNum, pageSize, criteria);
          }, 2000); // 60000ms = 1 minute

          setPollingTimer(timer);
        }
      } else {
        toast.error(response.message || 'Failed to fetch bids');
      }
    } catch (error) {
      console.error('Error fetching bids:', error);
      toast.error('Failed to fetch bids. Please try again later.');
    }
  };

  // Create a helper function that accepts criteria as parameter
  const fetchBidsWithCriteria = async (
    pageNum: number,
    pageSize: number,
    criteria: SearchCriteria = searchCriteria
  ) => {
    setLoading(true);
    try {
      // Construct query parameters using the passed criteria instead of state
      const queryParams = new URLSearchParams({
        Page: (pageNum + 1).toString(),
        Size: pageSize.toString(),
        ...(criteria.title && { Title: criteria.title }),
        ...(criteria.categories?.length > 0 && {
          Categories: criteria.categories.join(',')
        }),
        ...(criteria.statuses?.length > 0 && {
          Status: criteria.statuses.join(',')
        }),
        ...(criteria.bidTypes?.length > 0 && {
          Type: criteria.bidTypes.join(',')
        }),
        ...(criteria.adDate && {
          AdDate: criteria.adDate.toISOString()
        }),
        ...(criteria.openingDate && {
          OpeningDate: criteria.openingDate.toISOString()
        }),
        ...(criteria.awardedTo && { AwardedTo: criteria.awardedTo }),
        ...(criteria.contractNo && { ContractNo: criteria.contractNo })
      });

      const response = (await httpRequest(
        'GET',
        `/bid_portal/bid_details/get?${queryParams.toString()}`
      )) as APIResponse;

      if (response.status === 'success') {
        // ... rest of your fetchBids logic remains the same
        const transformedBids: any = response?.data?.Data?.map((bid) => ({
          contractNo: bid?.ContractNo,
          bidId: bid?.BidID?.toString() || '',
          bidType: bid?.Type,
          title: bid?.Title,
          adminNote: bid?.AdminNote || '',
          category:
            bid?.Categories?.map((cat) => cat.CategoryName).join(', ') || '',
          goLiveDate: bid?.GoLiveDate,
          dueDate: bid?.BidDeadLineDate,
          adDate: bid?.AdDate,
          openingDate: bid?.OpeningDate,
          status: bid?.Status,
          uploadedFiles:
            (bid?.Documents?.filter(
              (doc) => doc.DocumentDescription === 'Bid Document'
            )?.length || 0) + (bid.ChildBidDocuments?.length || 0),

          documentFiles:
            bid?.Documents?.map((doc) => ({
              fileName: doc.DocumentName,
              fileUrl: doc.DocumentUrl
            })) || [],
          downloads: bid?.Downloads,
          poFlag: false,
          poDocument: '',
          poLocation: '',
          signedPoFlag: false,
          invoiceFlag: false,
          invoiceDocument: '',
          invoiceLocation: '',
          departmentId: bid?.DepartmentID?.toString() || '',
          bidResults: bid?.bidResults,
          Po: bid?.Po,
          signedPo: bid?.signedPo,
          invoice: bid?.invoice,
          awardedTo: bid?.awardedTo || { Business: '' },
          awardedToVendor: bid?.AwardedToVendor?.Business || null, // Add this
          awardedToContact: bid?.awardedToContact || null, // Add this
          // now typed as BidDocument[]
          documents: (bid?.Documents || []) as BidDocument[],
          awardedToId: bid?.AwardedTo,
          awardAmount: bid?.AwardAmount,
          isAddendum: bid.IsAddendum || false, // Check for addendum
          childItems: [], // Initially empty, will be populated later,
          childBidDocuments: (bid?.ChildBidDocuments || []) as BidDocument[],
          isDocumentProcessing: bid?.IsDocumentProcessing
        }));

        setBids(transformedBids);
        setTotalCount(response.data.TotalRecords);

        const hasProcessingDocuments = transformedBids.some(
          (bid: any) => bid.isDocumentProcessing === true
        );

        if (pollingTimer) {
          clearTimeout(pollingTimer);
          setPollingTimer(null);
        }

        if (hasProcessingDocuments) {
          const timer = setTimeout(() => {
            fetchBidsWithoutLoader(pageNum, pageSize, criteria);
          }, 2000);

          setPollingTimer(timer);
        }
      } else {
        toast.error(response.message || 'Failed to fetch bids');
      }
    } catch (error) {
      console.error('Error fetching bids:', error);
      toast.error('Failed to fetch bids. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const fetchBids = async (pageNum: number, pageSize: number) => {
    await fetchBidsWithCriteria(pageNum, pageSize);
  };

  useEffect(() => {
    return () => {
      if (pollingTimer) {
        clearTimeout(pollingTimer);
      }
    };
  }, [pollingTimer]);

  useEffect(() => {
    fetchBids(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleSearch = () => {
    setPage(0);
    fetchBidsWithCriteria(0, rowsPerPage);
  };

  const handleClear = () => {
    const clearedCriteria = {
      title: '',
      categories: [],
      statuses: [],
      bidTypes: [],
      bidDeadline: null,
      adDate: null,
      openingDate: null,
      contractNo: '',
      awardedTo: ''
    };

    setSearchCriteria(clearedCriteria);
    setPage(0);

    fetchBidsWithCriteria(0, rowsPerPage, clearedCriteria);
    setExpandedRows({});
  };

  const openDeleteDialog = (bidId: string, bidTitle: string) => {
    setDeleteDialog({
      open: true,
      bidId,
      bidTitle
    });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({
      open: false,
      bidId: '',
      bidTitle: ''
    });
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await httpRequest(
        'DELETE',
        `/bid_portal/bid_details/delete/${deleteDialog.bidId}`
      );

      if (response.status === 'success') {
        toast.success('Bid deactivated successfully');

        // Check if current page will be empty after deletion
        const remainingBidsOnPage = bids.length - 1;

        if (remainingBidsOnPage === 0 && page > 0) {
          // Move to previous page if current page becomes empty
          setPage(page - 1);
          await fetchBids(page - 1, rowsPerPage);
        } else {
          // Stay on current page and refresh
          await fetchBids(page, rowsPerPage);
        }
      } else {
        toast.error(response.message || 'Failed to deactivate bid');
      }
    } catch (error) {
      console.error('Error deleting bid:', error);
      toast.error('Failed to deactivate bid. Please try again later.');
    } finally {
      closeDeleteDialog();
    }
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Helper function to format dates nicely
  const formatDateTime = (dateString: string) => {
    if (!dateString) return '-';

    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }).format(date);
    } catch (e) {
      return '-';
    }
  };

  // Get status color based on status text
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'open':
        return theme.palette.success.main;
      case 'closed':
        return theme.palette.error.main;
      case 'pending':
        return theme.palette.warning.main;
      case 'awarded':
        return theme.palette.info.main;
      default:
        return theme.palette.grey[500];
    }
  };

  const handleDownloadsClick = (bid: Bid) => {
    setDownloadDetailsState({
      isOpen: true,
      bidId: bid.bidId,
      bidDetails: {
        contractNo: bid.contractNo,
        title: bid.title,
        categories: bid.category
      }
    });
  };

  const handleDownloadsChildClick = (childBid: any, bid: Bid) => {
    setDownloadChildDetailsState({
      isOpen: true,
      bidId: childBid?.ChildBidID,
      parentBidId: bid.bidId,
      bidDetails: {
        contractNo: childBid?.ChildBidContractNo,
        title: childBid?.Title,
        categories:
          childBid?.Categories?.map((cat) => cat.CategoryName).join(', ') || ''
      }
    });
  };

  const handleCloseDownloadDetails = () => {
    setDownloadDetailsState({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });
    handleClear();
  };

  const handleCloseDownloadChildDetails = () => {
    setDownloadChildDetailsState({
      isOpen: false,
      parentBidId: '',
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });
    handleClear();
  };

  const handleCloseUploadedFilesDetails = () => {
    setUploadedFilesDetailsState({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });
    handleClear();
  };

  const handleCloseBidResultsDetails = () => {
    setBidResultsDetailsState({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: '',
        documents: []
      }
    });
    handleClear();
  };

  const handleCloseUploadPODetails = () => {
    setUploadPODetailsState({
      isOpen: false,
      bidId: '',
      bidDetails: {
        contractNo: '',
        title: '',
        categories: ''
      }
    });
    handleClear();
  };

  const fetchChildItems = async (bidId: string) => {
    // setLoadingChildItems((prev) => ({ ...prev, [bidId]: true }));

    try {
      const response = await httpRequest(
        'GET',
        `/bid_portal/childBid?BidID=${bidId}`,
        {},
        {}
      );

      if (response.status === 'success') {
        const childItems =
          response?.data?.data?.map((child: any) => ({
            ...child,
            bidId: child.ChildBidID?.toString() || child.bidId?.toString(),
            contractNo: child.ChildBidContractNo || child.contractNo
          })) || [];

        const updatedBids = bids?.map((bidItem) => {
          return bidItem.bidId === bidId
            ? { ...bidItem, childItems: childItems }
            : bidItem;
        });

        setBids(updatedBids);

        const hasProcessingDocuments = updatedBids.some((bid: any) =>
          bid.childItems.some(
            (child: any) => child.IsChildDocumentProcessing === true
          )
        );

        if (pollingTimer) {
          clearTimeout(pollingTimer);
          setPollingTimer(null);
        }

        if (hasProcessingDocuments) {
          const timer = setTimeout(() => {
            fetchChildItems(bidId);
          }, 2000);

          setPollingTimer(timer);
        }
      } else {
        console.error('Failed to fetch child items:', response);
        toast.error(response.message || 'Failed to load child items');
      }
    } catch (error) {
      console.error('Error fetching child items:', error);
      toast.error('Failed to fetch child items. Please try again later.');
    } finally {
      // setLoadingChildItems((prev) => ({ ...prev, [bidId]: false }));
    }
  };

  const toggleRowExpansion = (bidId: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [bidId]: !prev[bidId]
    }));

    if (!expandedRows[bidId]) {
      const currentBid = bids.find((bid) => bid.bidId === bidId);
      if (
        currentBid?.isAddendum &&
        (!currentBid.childItems || currentBid.childItems?.length === 0)
      ) {
        fetchChildItems(bidId);
      }
    }
  };

  const openChildDeleteDialog = (childBid: any, parentBidId: string) => {
    setChildDeleteDialog({
      open: true,
      childBidId: (childBid.ChildBidID || childBid.bidId)?.toString() || '',
      childBidTitle:
        childBid.ChildBidContractNo || childBid.contractNo || 'Unknown',
      parentBidId: parentBidId
    });
  };

  const closeChildDeleteDialog = () => {
    setChildDeleteDialog({
      open: false,
      childBidId: '',
      childBidTitle: '',
      parentBidId: ''
    });
  };
  const handleChildDeleteConfirm = async () => {
    try {
      const response = await httpRequest(
        'DELETE',
        `/bid_portal/childBid/${childDeleteDialog.childBidId}`
      );

      if (response.status === 'success') {
        toast.success('Child bid deleted successfully');

        const updatedBids = bids?.map((bidItem: any) => {
          if (bidItem.bidId === childDeleteDialog.parentBidId) {
            return {
              ...bidItem,
              childItems:
                bidItem.childItems?.filter(
                  (child: any) =>
                    (child.ChildBidID || child.bidId)?.toString() !==
                    childDeleteDialog.childBidId
                ) || []
            };
          }
          return bidItem;
        });

        setBids(updatedBids);

        // Optional: If you want to refresh from server
        // await fetchBids(page, rowsPerPage);
      } else {
        toast.error(response.message || 'Failed to delete child bid');
      }
    } catch (error) {
      console.error('Error deleting child bid:', error);
      toast.error('Failed to delete child bid. Please try again later.');
    } finally {
      closeChildDeleteDialog();
    }
  };

  const handleChildEdit = (bidId: string, childBidId: string) => {
    navigate(
      `/${locationState}/${township}/${uuid}/bid-portal/Admin/home/edit-child-bid/${bidId}/${childBidId}`
    );
  };

  return downloadChildDetailsState.isOpen ? (
    <DownloadChildBidDetails
      bidId={downloadChildDetailsState.bidId}
      bidDetails={downloadChildDetailsState.bidDetails}
      parentBidId={downloadChildDetailsState?.parentBidId}
      onBack={handleCloseDownloadChildDetails}
    />
  ) : uploadPODetailsState.isOpen ? (
    <UploadPODetails
      bidId={uploadPODetailsState.bidId}
      bidDetails={uploadPODetailsState.bidDetails}
      onBack={handleCloseUploadPODetails}
    />
  ) : bidResultsDetailsState.isOpen ? (
    <BidResultsDetails
      bidId={bidResultsDetailsState.bidId}
      bidDetails={bidResultsDetailsState.bidDetails}
      onBack={handleCloseBidResultsDetails}
    />
  ) : downloadDetailsState.isOpen ? (
    <DownloadDetails
      bidId={downloadDetailsState.bidId}
      bidDetails={downloadDetailsState.bidDetails}
      onBack={handleCloseDownloadDetails}
    />
  ) : uploadedFilesDetailsState.isOpen ? (
    // Show uploaded files details if opened
    <UploadedFilesDetails
      bidId={uploadedFilesDetailsState.bidId}
      bidDetails={uploadedFilesDetailsState.bidDetails}
      onBack={handleCloseUploadedFilesDetails}
    />
  ) : (
    <Box
      sx={{
        p: 3,
        background: alpha(theme.palette.background.default, 0.8),
        minHeight: '100vh'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            position: 'relative',
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: -8,
              left: 0,
              width: 50,
              height: 4,
              borderRadius: 2,
              backgroundColor: theme.palette.primary.main
            }
          }}
        >
          Home
        </Typography>

        {userRole === 'Admin' && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() =>
              navigate(
                `/${locationState}/${township}/${uuid}/bid-portal/Admin/home/create-bid`
              )
            }
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.2,
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
              fontWeight: 'bold',
              transition: 'transform 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.18)'
              }
            }}
          >
            Add New Bid
          </Button>
        )}
      </Box>

      {dropdownError && (
        <Alert
          severity="error"
          sx={{
            mb: 3,
            borderRadius: 2,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`
          }}
        >
          {dropdownError}
        </Alert>
      )}

      <Card
        sx={{
          mb: 4,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          overflow: 'hidden',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`
        }}
      >
        <Box
          sx={{
            p: 2.5,
            background: `linear-gradient(to right, ${alpha(
              theme.palette.primary.main,
              0.05
            )}, ${alpha(theme.palette.primary.main, 0.02)})`,
            borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
          }}
        >
          <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
            <SearchIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Search Filters
          </Typography>
        </Box>
        <CardContent sx={{ p: 3 }}>
          {loadingDropdowns ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2.5}>
              {/* First row - 3 fields */}
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  size="small"
                  fullWidth
                  label="Title"
                  variant="outlined"
                  value={searchCriteria.title}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      title: e.target.value
                    })
                  }
                  InputProps={{
                    sx: {
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      }
                    }
                  }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)'
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -6px) scale(0.75)'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      fontWeight: 500
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  size="small"
                  fullWidth
                  label="Awarded To"
                  variant="outlined"
                  value={searchCriteria.awardedTo}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      awardedTo: e.target.value
                    })
                  }
                  InputProps={{
                    sx: {
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      }
                    }
                  }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)'
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -6px) scale(0.75)'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      fontWeight: 500
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  size="small"
                  fullWidth
                  label="Contract No"
                  variant="outlined"
                  value={searchCriteria.contractNo}
                  onChange={(e) =>
                    setSearchCriteria({
                      ...searchCriteria,
                      contractNo: e.target.value
                    })
                  }
                  InputProps={{
                    sx: {
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      }
                    }
                  }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)'
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -6px) scale(0.75)'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      fontWeight: 500
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    sx={{
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)'
                      },
                      '&.Mui-focused': {
                        fontWeight: 500
                      },
                      backgroundColor: 'white',
                      paddingLeft: '4px',
                      paddingRight: '4px',
                      zIndex: 1
                    }}
                  >
                    Category
                  </InputLabel>
                  <Select
                    open={openCategorySelect}
                    onOpen={() => setOpenCategorySelect(true)}
                    onClose={() => setOpenCategorySelect(false)}
                    multiple
                    value={searchCriteria.categories}
                    onChange={(e) => {
                      const selectedValues = e.target.value as any[];

                      // Handle "Select All" logic
                      if (selectedValues.includes('SELECT_ALL')) {
                        const allCategoryIDs = categories?.map(
                          (cat) => cat.CategoryID
                        );
                        const isAllSelected =
                          searchCriteria.categories?.length ===
                          categories?.length;

                        // If all categories are selected, deselect all; otherwise, select all
                        const finalCategories = isAllSelected
                          ? []
                          : allCategoryIDs;

                        setSearchCriteria({
                          ...searchCriteria,
                          categories: finalCategories
                        });
                      } else {
                        // Ensure no invalid "Unknown" category is included
                        const validSelectedValues = selectedValues.filter(
                          (value) =>
                            categories.some((cat) => cat.CategoryID === value)
                        );

                        setSearchCriteria({
                          ...searchCriteria,
                          categories: validSelectedValues
                        });
                      }
                    }}
                    sx={{
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      },
                      '& .MuiSelect-select': {
                        paddingRight: '32px !important'
                      }
                    }}
                    renderValue={(selected) => {
                      const selectedArray = selected as number[];
                      const totalSelected = selectedArray?.length;

                      if (totalSelected === 0) {
                        return (
                          <Box sx={{ color: 'text.secondary' }}>
                            Select categories
                          </Box>
                        );
                      }

                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            width: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                          }}
                        >
                          {/* Scrollable chips container */}
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 0.5,
                              overflow: 'hidden',
                              flexGrow: 1,
                              maskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none',
                              WebkitMaskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none'
                            }}
                          >
                            {selectedArray?.map((CategoryID) => {
                              const categoryName =
                                categories.find(
                                  (c) => c.CategoryID === CategoryID
                                )?.CategoryName || 'Unknown';
                              return (
                                <Chip
                                  key={CategoryID}
                                  label={categoryName}
                                  size="small"
                                  sx={{
                                    height: 24,
                                    fontSize: '0.75rem',
                                    bgcolor: alpha(
                                      theme.palette.primary.main,
                                      0.1
                                    ),
                                    color: theme.palette.primary.main,
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    flexShrink: 0,
                                    maxWidth: '120px',
                                    '& .MuiChip-label': {
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      paddingLeft: '8px',
                                      paddingRight: '8px'
                                    }
                                  }}
                                />
                              );
                            })}
                          </Box>

                          {/* Count badge - always visible on the right */}
                          {totalSelected > 3 && (
                            <Chip
                              label={`${totalSelected}`}
                              size="small"
                              sx={{
                                height: 24,
                                fontSize: '0.75rem',
                                bgcolor: alpha(theme.palette.primary.main, 0.2),
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                borderRadius: 1,
                                minWidth: '40px',
                                flexShrink: 0,
                                position: 'absolute',
                                right: 0,
                                backgroundColor: 'white',
                                boxShadow: '-4px 0 8px rgba(255, 255, 255, 0.9)'
                              }}
                            />
                          )}
                        </Box>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 350,
                          borderRadius: 1.5,
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                          marginTop: 1
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                  >
                    {/* Select All Option */}
                    <MenuItem value="SELECT_ALL">
                      <Checkbox
                        checked={
                          searchCriteria.categories?.length ===
                          categories?.length
                        }
                        indeterminate={
                          searchCriteria.categories?.length > 0 &&
                          searchCriteria.categories?.length < categories?.length
                        }
                      />
                      <ListItemText
                        primary="Select All"
                        sx={{ fontWeight: 'bold', color: 'primary.main' }}
                      />
                    </MenuItem>

                    {/* Individual Category Options */}
                    {categories?.map((category) => (
                      <MenuItem
                        key={category.CategoryID}
                        value={category.CategoryID}
                        sx={{
                          fontSize: '0.875rem',
                          '&.Mui-selected': {
                            backgroundColor: alpha(
                              theme.palette.primary.main,
                              0.08
                            ),
                            '&:hover': {
                              backgroundColor: alpha(
                                theme.palette.primary.main,
                                0.12
                              )
                            }
                          }
                        }}
                      >
                        <Checkbox
                          checked={
                            searchCriteria.categories.indexOf(
                              category.CategoryID
                            ) > -1
                          }
                        />
                        {category.CategoryName}
                      </MenuItem>
                    ))}

                    <MenuItem
                      disableRipple
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        borderTop: '1px solid #ddd',
                        mt: 1,
                        pt: 1
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: '#1976d2',
                          color: 'white',
                          padding: '5px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: '600'
                        }}
                        onClick={() => setOpenCategorySelect(false)}
                      >
                        Apply
                      </button>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    sx={{
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)'
                      },
                      '&.Mui-focused': {
                        fontWeight: 500
                      },
                      backgroundColor: 'white',
                      paddingLeft: '4px',
                      paddingRight: '4px',
                      zIndex: 1
                    }}
                  >
                    Status
                  </InputLabel>
                  <Select
                    open={openStatusSelect}
                    onOpen={() => setOpenStatusSelect(true)}
                    onClose={() => setOpenStatusSelect(false)}
                    multiple
                    value={searchCriteria.statuses}
                    onChange={(e) => {
                      const selectedValues = e.target.value as any[];

                      // Handle "Select All" logic
                      if (selectedValues.includes('SELECT_ALL')) {
                        const allStatusIDs = statuses?.map(
                          (status) => status.StatusID
                        );
                        const isAllSelected =
                          searchCriteria.statuses?.length === statuses?.length;

                        // If all statuses are selected, deselect all; otherwise, select all
                        const finalStatuses = isAllSelected ? [] : allStatusIDs;

                        setSearchCriteria({
                          ...searchCriteria,
                          statuses: finalStatuses
                        });
                      } else {
                        // Ensure no invalid "Unknown" status is included
                        const validSelectedValues = selectedValues.filter(
                          (value) =>
                            statuses.some((status) => status.StatusID === value)
                        );

                        setSearchCriteria({
                          ...searchCriteria,
                          statuses: validSelectedValues
                        });
                      }
                    }}
                    sx={{
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      },
                      '& .MuiSelect-select': {
                        paddingRight: '32px !important'
                      }
                    }}
                    renderValue={(selected) => {
                      const selectedArray = selected as number[];
                      const totalSelected = selectedArray?.length;

                      if (totalSelected === 0) {
                        return (
                          <Box sx={{ color: 'text.secondary' }}>
                            Select statuses
                          </Box>
                        );
                      }

                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            width: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                          }}
                        >
                          {/* Scrollable chips container */}
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 0.5,
                              overflow: 'hidden',
                              flexGrow: 1,
                              maskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none',
                              WebkitMaskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none'
                            }}
                          >
                            {selectedArray?.map((statusId) => {
                              const statusName =
                                statuses.find((s) => s.StatusID === statusId)
                                  ?.Status || 'Unknown';
                              return (
                                <Chip
                                  key={statusId}
                                  label={statusName}
                                  size="small"
                                  sx={{
                                    height: 24,
                                    fontSize: '0.75rem',
                                    bgcolor: alpha(
                                      theme.palette.primary.main,
                                      0.1
                                    ),
                                    color: theme.palette.primary.main,
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    flexShrink: 0,
                                    maxWidth: '120px',
                                    '& .MuiChip-label': {
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      paddingLeft: '8px',
                                      paddingRight: '8px'
                                    }
                                  }}
                                />
                              );
                            })}
                          </Box>

                          {/* Count badge - always visible on the right */}
                          {totalSelected > 3 && (
                            <Chip
                              label={`${totalSelected}`}
                              size="small"
                              sx={{
                                height: 24,
                                fontSize: '0.75rem',
                                bgcolor: alpha(theme.palette.primary.main, 0.2),
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                borderRadius: 1,
                                minWidth: '40px',
                                flexShrink: 0,
                                position: 'absolute',
                                right: 0,
                                backgroundColor: 'white',
                                boxShadow: '-4px 0 8px rgba(255, 255, 255, 0.9)'
                              }}
                            />
                          )}
                        </Box>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 350,
                          borderRadius: 1.5,
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                          marginTop: 1
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                  >
                    {/* Select All Option */}
                    <MenuItem value="SELECT_ALL">
                      <Checkbox
                        checked={
                          searchCriteria.statuses?.length === statuses?.length
                        }
                        indeterminate={
                          searchCriteria.statuses?.length > 0 &&
                          searchCriteria.statuses?.length < statuses?.length
                        }
                      />
                      <ListItemText
                        primary="Select All"
                        sx={{ fontWeight: 'bold', color: 'primary.main' }}
                      />
                    </MenuItem>

                    {/* Individual Status Options */}
                    {statuses?.map((status) => (
                      <MenuItem
                        key={status.StatusID}
                        value={status.StatusID}
                        sx={{
                          fontSize: '0.875rem',
                          '&.Mui-selected': {
                            backgroundColor: alpha(
                              theme.palette.primary.main,
                              0.08
                            ),
                            '&:hover': {
                              backgroundColor: alpha(
                                theme.palette.primary.main,
                                0.12
                              )
                            }
                          }
                        }}
                      >
                        <Checkbox
                          checked={
                            searchCriteria.statuses.indexOf(status.StatusID) >
                            -1
                          }
                        />
                        {status.Status}
                      </MenuItem>
                    ))}

                    <MenuItem
                      disableRipple
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        borderTop: '1px solid #ddd',
                        mt: 1,
                        pt: 1
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: '#1976d2',
                          color: 'white',
                          padding: '5px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: '600'
                        }}
                        onClick={() => setOpenStatusSelect(false)}
                      >
                        Apply
                      </button>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel
                    sx={{
                      color: theme.palette.text.secondary,
                      fontSize: '0.875rem',
                      transform: 'translate(14px, 11px) scale(1)',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)'
                      },
                      '&.Mui-focused': {
                        fontWeight: 500
                      },
                      backgroundColor: 'white',
                      paddingLeft: '4px',
                      paddingRight: '4px',
                      zIndex: 1
                    }}
                  >
                    Type
                  </InputLabel>
                  <Select
                    open={openTypeSelect}
                    onOpen={() => setOpenTypeSelect(true)}
                    onClose={() => setOpenTypeSelect(false)}
                    multiple
                    value={searchCriteria.bidTypes}
                    onChange={(e) => {
                      const selectedValues = e.target.value as any[];

                      // Handle "Select All" logic
                      if (selectedValues.includes('SELECT_ALL')) {
                        const allTypeIDs = types?.map((type) => type.TypeID);
                        const isAllSelected =
                          searchCriteria.bidTypes?.length === types?.length;

                        // If all types are selected, deselect all; otherwise, select all
                        const finalTypes = isAllSelected ? [] : allTypeIDs;

                        setSearchCriteria({
                          ...searchCriteria,
                          bidTypes: finalTypes
                        });
                      } else {
                        // Ensure no invalid "Unknown" type is included
                        const validSelectedValues = selectedValues.filter(
                          (value) => types.some((type) => type.TypeID === value)
                        );

                        setSearchCriteria({
                          ...searchCriteria,
                          bidTypes: validSelectedValues
                        });
                      }
                    }}
                    sx={{
                      borderRadius: 1.5,
                      height: 40,
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.5)
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: 2
                      },
                      '& .MuiSelect-select': {
                        paddingRight: '32px !important'
                      }
                    }}
                    renderValue={(selected) => {
                      const selectedArray = selected as number[];
                      const totalSelected = selectedArray?.length;

                      if (totalSelected === 0) {
                        return (
                          <Box sx={{ color: 'text.secondary' }}>
                            Select types
                          </Box>
                        );
                      }

                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            width: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                          }}
                        >
                          {/* Scrollable chips container */}
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 0.5,
                              overflow: 'hidden',
                              flexGrow: 1,
                              maskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none',
                              WebkitMaskImage:
                                totalSelected > 1
                                  ? 'linear-gradient(to right, black calc(100% - 60px), transparent 100%)'
                                  : 'none'
                            }}
                          >
                            {selectedArray?.map((TypeID) => {
                              const TypeName =
                                types.find((t) => t.TypeID === TypeID)?.Type ||
                                'Unknown';
                              return (
                                <Chip
                                  key={TypeID}
                                  label={TypeName}
                                  size="small"
                                  sx={{
                                    height: 24,
                                    fontSize: '0.75rem',
                                    bgcolor: alpha(
                                      theme.palette.primary.main,
                                      0.1
                                    ),
                                    color: theme.palette.primary.main,
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    flexShrink: 0,
                                    maxWidth: '120px',
                                    '& .MuiChip-label': {
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      paddingLeft: '8px',
                                      paddingRight: '8px'
                                    }
                                  }}
                                />
                              );
                            })}
                          </Box>

                          {/* Count badge - always visible on the right */}
                          {totalSelected > 3 && (
                            <Chip
                              label={`${totalSelected}`}
                              size="small"
                              sx={{
                                height: 24,
                                fontSize: '0.75rem',
                                bgcolor: alpha(theme.palette.primary.main, 0.2),
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                borderRadius: 1,
                                minWidth: '40px',
                                flexShrink: 0,
                                position: 'absolute',
                                right: 0,
                                backgroundColor: 'white',
                                boxShadow: '-4px 0 8px rgba(255, 255, 255, 0.9)'
                              }}
                            />
                          )}
                        </Box>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 350,
                          borderRadius: 1.5,
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                          marginTop: 1
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                  >
                    {/* Select All Option */}
                    <MenuItem value="SELECT_ALL">
                      <Checkbox
                        checked={
                          searchCriteria.bidTypes?.length === types?.length
                        }
                        indeterminate={
                          searchCriteria.bidTypes?.length > 0 &&
                          searchCriteria.bidTypes?.length < types?.length
                        }
                      />
                      <ListItemText
                        primary="Select All"
                        sx={{ fontWeight: 'bold', color: 'primary.main' }}
                      />
                    </MenuItem>

                    {/* Individual Type Options */}
                    {types?.map((type) => (
                      <MenuItem
                        key={type.TypeID}
                        value={type.TypeID}
                        sx={{
                          fontSize: '0.875rem',
                          '&.Mui-selected': {
                            backgroundColor: alpha(
                              theme.palette.primary.main,
                              0.08
                            ),
                            '&:hover': {
                              backgroundColor: alpha(
                                theme.palette.primary.main,
                                0.12
                              )
                            }
                          }
                        }}
                      >
                        <Checkbox
                          checked={
                            searchCriteria.bidTypes.indexOf(type.TypeID) > -1
                          }
                        />
                        {type.Type}
                      </MenuItem>
                    ))}

                    <MenuItem
                      disableRipple
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        borderTop: '1px solid #ddd',
                        mt: 1,
                        pt: 1
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: '#1976d2',
                          color: 'white',
                          padding: '5px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: '600'
                        }}
                        onClick={() => setOpenTypeSelect(false)}
                      >
                        Apply
                      </button>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Second row with date picker and buttons */}
              <Grid item xs={12} sm={4} md={3}>
                <DatePicker
                  label="Ad Date"
                  value={searchCriteria.adDate}
                  onChange={(date) =>
                    setSearchCriteria({ ...searchCriteria, adDate: date })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      variant: 'outlined',
                      InputProps: {
                        startAdornment: (
                          <CalendarToday
                            sx={{
                              color: theme.palette.text.secondary,
                              mr: 1,
                              fontSize: '1rem'
                            }}
                          />
                        ),
                        sx: {
                          borderRadius: 1.5,
                          height: 40,
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: alpha(theme.palette.primary.main, 0.5)
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2
                          }
                        }
                      },
                      sx: {
                        '& .MuiInputLabel-root': {
                          color: theme.palette.text.secondary,
                          fontSize: '0.875rem',
                          transform: 'translate(14px, 11px) scale(1)'
                        },
                        '& .MuiInputLabel-shrink': {
                          transform: 'translate(14px, -6px) scale(0.75)'
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          fontWeight: 500
                        }
                      }
                    },
                    desktopPaper: {
                      sx: {
                        borderRadius: 2,
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                        '& .MuiPickersDay-root.Mui-selected': {
                          backgroundColor: theme.palette.primary.main,
                          '&:hover': {
                            backgroundColor: theme.palette.primary.dark
                          }
                        }
                      }
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <DatePicker
                  label="Opening Date"
                  value={searchCriteria.openingDate}
                  onChange={(date) =>
                    setSearchCriteria({ ...searchCriteria, openingDate: date })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      variant: 'outlined',
                      InputProps: {
                        startAdornment: (
                          <CalendarToday
                            sx={{
                              color: theme.palette.text.secondary,
                              mr: 1,
                              fontSize: '1rem'
                            }}
                          />
                        ),
                        sx: {
                          borderRadius: 1.5,
                          height: 40,
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: alpha(theme.palette.primary.main, 0.5)
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2
                          }
                        }
                      },
                      sx: {
                        '& .MuiInputLabel-root': {
                          color: theme.palette.text.secondary,
                          fontSize: '0.875rem',
                          transform: 'translate(14px, 11px) scale(1)'
                        },
                        '& .MuiInputLabel-shrink': {
                          transform: 'translate(14px, -6px) scale(0.75)'
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          fontWeight: 500
                        }
                      }
                    },
                    desktopPaper: {
                      sx: {
                        borderRadius: 2,
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                        '& .MuiPickersDay-root.Mui-selected': {
                          backgroundColor: theme.palette.primary.main,
                          '&:hover': {
                            backgroundColor: theme.palette.primary.dark
                          }
                        }
                      }
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    justifyContent: 'flex-end',
                    height: '100%',
                    alignItems: 'center'
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSearch}
                    startIcon={<SearchIcon />}
                    size="small"
                    sx={{
                      borderRadius: 1.5,
                      px: 3,
                      py: 0.8,
                      fontWeight: 'bold',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.18)',
                        transform: 'translateY(-2px)'
                      }
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleClear}
                    startIcon={<ClearAll />}
                    size="small"
                    sx={{
                      borderRadius: 1.5,
                      px: 3,
                      py: 0.8,
                      fontWeight: 'bold',
                      borderWidth: '1px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderWidth: '1px',
                        backgroundColor: alpha(theme.palette.primary.main, 0.04)
                      }
                    }}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>

      <Paper
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`
        }}
      >
        <Box
          sx={{
            p: 2.5,
            bgcolor: `linear-gradient(to right, ${alpha(
              theme.palette.primary.main,
              0.05
            )}, ${alpha(theme.palette.primary.main, 0.02)})`,
            borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
            Bids
          </Typography>
          {!loading && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              Total Results: {totalCount}
            </Typography>
          )}
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer>
              <Table
                sx={{
                  '& .MuiTableCell-head': {
                    bgcolor: alpha(theme.palette.primary.main, 0.03),
                    fontWeight: 'bold',
                    color: theme.palette.text.primary,
                    py: 2
                  },
                  '& .MuiTableCell-body': {
                    py: 1.8
                  }
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 50 }}></TableCell>
                    <TableCell>Contract No.</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Ad Date</TableCell>
                    <TableCell>Opening Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="center">Attachments</TableCell>
                    <TableCell align="center">Downloads</TableCell>
                    <TableCell>Awarded To</TableCell>
                    {/* <TableCell>Bid Results </TableCell>
                    <TableCell>PO</TableCell> */}
                    <TableCell>Award Amount</TableCell>
                    {userRole === 'Admin' && (
                      <TableCell align="center">Actions</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bids?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={16} align="center" sx={{ py: 5 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                          }}
                        >
                          <Warning
                            sx={{
                              fontSize: 40,
                              color: alpha(theme.palette.text.secondary, 0.6)
                            }}
                          />
                          <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ fontWeight: 500 }}
                          >
                            No bids found. Try adjusting your search criteria.
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    bids?.map((bid: any) => (
                      <React.Fragment key={bid.bidId}>
                        {/* Main Row */}
                        <TableRow
                          hover
                          sx={{
                            '&:hover': {
                              bgcolor: alpha(theme.palette.primary.main, 0.03)
                            },
                            transition: 'background-color 0.2s ease',
                            '&:nth-of-type(even)': {
                              bgcolor: alpha(
                                theme.palette.background.default,
                                0.4
                              )
                            }
                          }}
                        >
                          <TableCell>
                            {/* Check if this bid has isAddendum */}
                            {bid.isAddendum && (
                              <IconButton
                                size="small"
                                onClick={() => toggleRowExpansion(bid.bidId)}
                                sx={{
                                  transition: 'transform 0.2s ease',
                                  color: theme.palette.primary.main
                                }}
                              >
                                {expandedRows[bid.bidId] ? (
                                  <KeyboardArrowDown />
                                ) : (
                                  <KeyboardArrowRight />
                                )}
                              </IconButton>
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 500 }}>
                            {bid.contractNo || '-'}
                          </TableCell>
                          <TableCell>
                            {bid.bidType ? (
                              <Chip
                                label={bid.bidType}
                                size="small"
                                sx={{
                                  bgcolor: alpha(theme.palette.info.main, 0.1),
                                  color: theme.palette.info.main,
                                  fontWeight: 500,
                                  borderRadius: 1
                                }}
                              />
                            ) : null}
                          </TableCell>
                          <TableCell
                            sx={{
                              maxWidth: 220,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            <Tooltip title={bid.title} arrow placement="top">
                              <span>{bid.title}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            {bid.adDate
                              ? new Date(bid.adDate).toLocaleDateString('en-US')
                              : '-'}
                          </TableCell>
                          <TableCell>
                            {bid.openingDate
                              ? formatDateTime(bid.openingDate)
                              : '-'}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={bid.status}
                              size="small"
                              sx={{
                                bgcolor: alpha(getStatusColor(bid.status), 0.1),
                                color: getStatusColor(bid.status),
                                fontWeight: 'bold',
                                borderRadius: 1
                              }}
                            />
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 500 }}>
                            {
                              // Check if document processing is false to show the link or a loading spinner
                              !bid.isDocumentProcessing ? (
                                <Link
                                  component="button"
                                  variant="body2"
                                  onClick={() => handleUploadsClick(bid)}
                                  sx={{
                                    color: theme.palette.primary.main,
                                    fontWeight: 'bold',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      textDecoration: 'underline',
                                      color: theme.palette.primary.dark
                                    }
                                  }}
                                >
                                  {bid.uploadedFiles}
                                </Link>
                              ) : (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: theme.palette.primary.main,
                                    fontWeight: 'bold'
                                  }}
                                >
                                  Uploading...
                                </Typography>
                              )
                            }
                          </TableCell>

                          <TableCell align="center" sx={{ fontWeight: 500 }}>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => handleDownloadsClick(bid)}
                              sx={{
                                color: theme.palette.primary.main,
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline',
                                  color: theme.palette.primary.dark
                                }
                              }}
                            >
                              {bid.downloads}
                            </Link>
                          </TableCell>
                          <TableCell
                            sx={{
                              maxWidth: 180,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            <Tooltip
                              arrow
                              placement="top"
                              title={
                                bid?.awardedToVendor ? (
                                  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                      {bid.awardedToVendor}
                                    </Typography>
                                    {bid.awardedToContact?.name && (
                                      <Typography variant="body2">Contact: {bid.awardedToContact.name}</Typography>
                                    )}
                                    {bid.awardedToContact?.email && (
                                      <Typography variant="body2">Email: {bid.awardedToContact.email}</Typography>
                                    )}
                                    {bid.awardedToContact?.phone && (
                                      <Typography variant="body2">Phone: {bid.awardedToContact.phone}</Typography>
                                    )}
                                  </Box>
                                ) : ''
                              }
                            >
                              <span>{bid?.awardedToVendor || '-'}</span>
                            </Tooltip>
                          </TableCell>

                          <TableCell sx={{ fontWeight: 500 }}>
                            {bid.awardAmount ? `$${addCommaWithTwoDecimals(bid.awardAmount)}` : '-'}
                          </TableCell>

                          {userRole === 'Admin' && (
                            <TableCell align="center">
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  gap: 0.75
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    navigate(
                                      `/${locationState}/${township}/${uuid}/bid-portal/Admin/home/edit-bid/${bid.bidId}`
                                    )
                                  }
                                  sx={{
                                    color: '#4285f4',
                                    backgroundColor: alpha('#4285f4', 0.05),
                                    '&:hover': {
                                      backgroundColor: alpha('#4285f4', 0.15)
                                    },
                                    transition: 'all 0.2s',
                                    padding: 1,
                                    border: `1px solid ${alpha('#4285f4', 0.2)}`
                                  }}
                                >
                                  <Edit fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    openDeleteDialog(bid.bidId, bid.title)
                                  }
                                  sx={{
                                    color: theme.palette.error.main,
                                    backgroundColor: alpha(
                                      theme.palette.error.main,
                                      0.05
                                    ),
                                    '&:hover': {
                                      backgroundColor: alpha(
                                        theme.palette.error.main,
                                        0.15
                                      )
                                    },
                                    transition: 'all 0.2s',
                                    padding: 1,
                                    border: `1px solid ${alpha(
                                      theme.palette.error.main,
                                      0.2
                                    )}`
                                  }}
                                >
                                  <Delete fontSize="small" />
                                </IconButton>
                              </Box>
                            </TableCell>
                          )}
                        </TableRow>

                        <TableRow>
                          <TableCell
                            colSpan={16} // Updated to match parent table column count
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                          >
                            <Collapse
                              in={expandedRows[bid.bidId]}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box sx={{ margin: 2 }}>
                                {bid.childItems && bid.childItems.length > 0 ? (
                                  <Table
                                    sx={{
                                      bgcolor: alpha(
                                        theme.palette.grey[100],
                                        0.5
                                      )
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                          sx={{
                                            fontWeight: 'bold',
                                            bgcolor: alpha(
                                              theme.palette.primary.main,
                                              0.08
                                            )
                                          }}
                                        >
                                          Contract No.
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: 'bold',
                                            bgcolor: alpha(
                                              theme.palette.primary.main,
                                              0.08
                                            )
                                          }}
                                        >
                                          Attachments
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            fontWeight: 'bold',
                                            bgcolor: alpha(
                                              theme.palette.primary.main,
                                              0.08
                                            )
                                          }}
                                        >
                                          Vendor Downloads
                                        </TableCell>
                                        {userRole === 'Admin' && (
                                          <TableCell
                                            align="center"
                                            sx={{
                                              fontWeight: 'bold',
                                              bgcolor: alpha(
                                                theme.palette.primary.main,
                                                0.08
                                              )
                                            }}
                                          >
                                            Actions
                                          </TableCell>
                                        )}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {bid.childItems.map((childBid) => (
                                        <TableRow
                                          key={
                                            childBid.ChildBidID ||
                                            childBid.bidId
                                          }
                                        >
                                          <TableCell sx={{ fontWeight: 500 }}>
                                            {childBid.ChildBidContractNo || '-'}
                                          </TableCell>

                                          <TableCell sx={{ fontWeight: 500 }}>
                                            {!childBid.IsChildDocumentProcessing ? (
                                              <Link
                                                component="button"
                                                variant="body2"
                                                onClick={() =>
                                                  handleUploadsClick(childBid)
                                                }
                                                sx={{
                                                  color:
                                                    theme.palette.primary.main,
                                                  fontWeight: 'bold',
                                                  textDecoration: 'none',
                                                  cursor: 'pointer',
                                                  '&:hover': {
                                                    textDecoration: 'underline',
                                                    color:
                                                      theme.palette.primary.dark
                                                  }
                                                }}
                                              >
                                                {childBid.ChildBidDocuments
                                                  ?.length || 0}
                                              </Link>
                                            ) : (
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  color:
                                                    theme.palette.primary.main,
                                                  fontWeight: 'bold'
                                                }}
                                              >
                                                Uploading...
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell sx={{ fontWeight: 500 }}>
                                            <Link
                                              onClick={() =>
                                                handleDownloadsChildClick(
                                                  childBid,
                                                  bid
                                                )
                                              }
                                              component="button"
                                              variant="body2"
                                              sx={{
                                                color:
                                                  theme.palette.primary.main,
                                                fontWeight: 'bold',
                                                textDecoration: 'none',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                  textDecoration: 'underline',
                                                  color:
                                                    theme.palette.primary.dark
                                                }
                                              }}
                                            >
                                              {childBid.Downloads || 0}
                                            </Link>
                                          </TableCell>

                                          {userRole === 'Admin' && (
                                            <TableCell align="center">
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 0.75
                                                }}
                                              >
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    handleChildEdit(
                                                      bid?.bidId,
                                                      childBid?.ChildBidID
                                                    )
                                                  }
                                                  sx={{
                                                    color: '#4285f4',
                                                    backgroundColor: alpha(
                                                      '#4285f4',
                                                      0.05
                                                    ),
                                                    '&:hover': {
                                                      backgroundColor: alpha(
                                                        '#4285f4',
                                                        0.15
                                                      )
                                                    },
                                                    transition: 'all 0.2s',
                                                    padding: 0.5,
                                                    border: `1px solid ${alpha(
                                                      '#4285f4',
                                                      0.2
                                                    )}`
                                                  }}
                                                >
                                                  <Edit fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    openChildDeleteDialog(
                                                      childBid,
                                                      bid.bidId
                                                    )
                                                  }
                                                  sx={{
                                                    color:
                                                      theme.palette.error.main,
                                                    backgroundColor: alpha(
                                                      theme.palette.error.main,
                                                      0.05
                                                    ),
                                                    '&:hover': {
                                                      backgroundColor: alpha(
                                                        theme.palette.error
                                                          .main,
                                                        0.15
                                                      )
                                                    },
                                                    transition: 'all 0.2s',
                                                    padding: 0.5,
                                                    border: `1px solid ${alpha(
                                                      theme.palette.error.main,
                                                      0.2
                                                    )}`
                                                  }}
                                                >
                                                  <Delete fontSize="small" />
                                                </IconButton>
                                              </Box>
                                            </TableCell>
                                          )}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ p: 2, textAlign: 'center' }}
                                  >
                                    No child items found for this bid.
                                  </Typography>
                                )}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                borderTop: `1px solid ${alpha(
                  theme.palette.primary.main,
                  0.1
                )}`,
                bgcolor: alpha(theme.palette.background.paper, 0.5)
              }}
            >
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
                rowsPerPageOptions={[10, 25, 50, 100]}
                sx={{
                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows':
                    {
                      fontWeight: 500
                    },
                  '& .MuiTablePagination-select': {
                    borderRadius: 1.5,
                    '&:focus': {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05)
                    }
                  },
                  '& .MuiTablePagination-actions': {
                    '& .MuiIconButton-root': {
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1)
                      }
                    }
                  }
                }}
              />
            </Box>
          </>
        )}
      </Paper>

      {/* Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={closeDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
            minWidth: { xs: '85%', sm: 400 },
            border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1,
            pt: 2.5,
            color: theme.palette.error.main,
            fontWeight: 'bold',
            borderBottom: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
            backgroundColor: alpha(theme.palette.error.main, 0.03)
          }}
        >
          <Warning color="error" />
          Confirm Deactivation
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ color: theme.palette.text.primary }}
          >
            Are you sure you want to deactivate the bid:{' '}
            <Typography
              component="span"
              fontWeight="bold"
              color={theme.palette.text.primary}
            >
              {deleteDialog.bidTitle}
            </Typography>
            ? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
          <Button
            onClick={closeDeleteDialog}
            variant="outlined"
            sx={{
              borderRadius: 1.5,
              px: 3,
              py: 1,
              fontWeight: 'medium',
              borderWidth: '1.5px',
              '&:hover': {
                borderWidth: '1.5px',
                backgroundColor: alpha(theme.palette.primary.main, 0.04)
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            autoFocus
            startIcon={<Delete />}
            sx={{
              borderRadius: 1.5,
              px: 3,
              py: 1,
              fontWeight: 'bold',
              boxShadow: '0 4px 10px rgba(211, 47, 47, 0.25)',
              '&:hover': {
                boxShadow: '0 6px 12px rgba(211, 47, 47, 0.35)'
              }
            }}
          >
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={childDeleteDialog.open}
        onClose={closeChildDeleteDialog}
        aria-labelledby="child-alert-dialog-title"
        aria-describedby="child-alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
            minWidth: { xs: '85%', sm: 400 },
            border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle
          id="child-alert-dialog-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1,
            pt: 2.5,
            color: theme.palette.error.main,
            fontWeight: 'bold',
            borderBottom: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
            backgroundColor: alpha(theme.palette.error.main, 0.03)
          }}
        >
          <Warning color="error" />
          Confirm Deactivation
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <DialogContentText
            id="child-alert-dialog-description"
            sx={{ color: theme.palette.text.primary }}
          >
            Are you sure you want to delete the bid:{' '}
            <Typography
              component="span"
              fontWeight="bold"
              color={theme.palette.text.primary}
            >
              {childDeleteDialog.childBidTitle}
            </Typography>
            ? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
          <Button
            onClick={closeChildDeleteDialog}
            variant="outlined"
            sx={{
              borderRadius: 1.5,
              px: 3,
              py: 1,
              fontWeight: 'medium',
              borderWidth: '1.5px',
              '&:hover': {
                borderWidth: '1.5px',
                backgroundColor: alpha(theme.palette.primary.main, 0.04)
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleChildDeleteConfirm}
            color="error"
            variant="contained"
            autoFocus
            startIcon={<Delete />}
            sx={{
              borderRadius: 1.5,
              px: 3,
              py: 1,
              fontWeight: 'bold',
              boxShadow: '0 4px 10px rgba(211, 47, 47, 0.25)',
              '&:hover': {
                boxShadow: '0 6px 12px rgba(211, 47, 47, 0.35)'
              }
            }}
          >
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SearchBidsPage;
